import { PLATFORM_LABELS, SocialPlatform } from "shared/constants";

import { useLinkedInAuth } from "./useLinkedInAuth";
import { useMetaAuth } from "./useMetaAuth";
import { useTwitterAuth } from "./useTwitterAuth";

// eslint-disable-next-line import/prefer-default-export
export function useSocialAuth(platformLabel: keyof typeof PLATFORM_LABELS) {
  const platform = PLATFORM_LABELS[platformLabel];

  if (platform === SocialPlatform.LINKEDIN) {
    return useLinkedInAuth();
  }

  if (platform === SocialPlatform.TWITTER) {
    return useTwitterAuth();
  }

  return useMetaAuth({ platform });
}
